export default __webpack_public_path__ + "static/media/whitehatjrLogo.7120d469.png";